<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Commission Deferred</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Commission Deferred</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'CommissionDeferredList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body table-responsive p-0">
              <table class="table table-striped">
                <tbody>
                
                  <tr>
                    <td><b>ID</b></td>
                    <td>{{ value.id }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Client Reference-Id</b></td>
                    <td>{{ value.clientRefId }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Account-Id</b></td>
                    <td>{{ value.accountId }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Commission config</b></td>
                    <td>{{ value.commissionConfigId }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Amount</b></td>
                    <td>{{ value.amount }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Commissioned amount</b></td>
                    <td>{{ value.commissionAmount }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Can migrate</b></td>
                    <td>{{ value.canMigrate }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Disbursement-Id</b></td>
                    <td>{{ value.disbursementId }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Disbursement Reference-Id</b></td>
                    <td>{{ value.disbursementRefId }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Expected Disbursement Date</b></td>
                    <td>{{ value.expectedDisbursementDate }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Actual Disbursement Date</b></td>
                    <td>{{ value.actualDisbursementDate }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Disbursed amount</b></td>
                    <td>{{ value.disbursementAmount }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Disbursement status</b></td>
                    <td>{{ value.disbursementStatus }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>Disbursement message</b></td>
                    <td>{{ value.disbursementMessage }}</td>
                  </tr>
                  
                  <tr>
                    <td><b>App-Id</b></td>
                    <td>{{ value.appId }}</td>
                  </tr>
                  
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
      
    </section>
  </div>
</template>

<script>
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from "@/services/api";
import axios from "axios";


export default {
  name: "CommissionDeferredShow",
  data: () => ({
    value: {
      
    },
    pre: {
      
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      

      await this.getDetail(this.params.id).then(detail => {
        this.value = detail;
      });

      this.is_loading = false;
    },
    getDetail: function (id) {
      let _this = this;
      return new Promise(resolve => {
        let api_url = "/commission_deferreds/" + id;
        _this.is_loading = true;
        axios.get(api_url)
          .then(response => {
            _this.value = response.data;
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          })
          .finally(() => {
            _this.is_loading = false;
          });
      });
    },
  },
  created() {
    this.$emit("update:layout", MasterLayout);
  },
}
</script>
        